import React, { useContext, useEffect, useState } from 'react';
import Layout from '../Component/layout/main-layout';
import { useTranslation } from 'react-i18next';
import { ArrowDropDown, ReadMore } from '@mui/icons-material';
import LotAngle from '../Images/icons/LotAngle.svg'
import layoutBgImg from '../Images/layout/complaint-board.svg';
import layoutBgImg2 from '../Images/layout/others.jpg';
import { Context } from '../Store/context';
import Loading from '../Component/loader/loader';
import GlobalLayout from '../Component/layout/global-layout';
import { useParams } from 'react-router-dom';
import { Modal, Box, Typography, Button } from '@mui/material';
import { Get } from '../api/services/api_helpers';

const ComplaintBoard = () => {
  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [complaint, setComplaint] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { id } = useParams();
  const { showError } = useContext(Context);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  useEffect(() => {
    setIsLoading(true);
    const getComplainsId = async () => {
      try {
        const response = await Get(`court-complain-categories/${id}`);
        setComplaint(response.complaints);
        setIsLoading(false);
      } catch (error) {
        showError(error.message);
        setIsLoading(false);
      }
    };
    getComplainsId();
  }, [id, showError]);


  const getCategory = (c) => {
    if (!c || !c.category_type) return t('other');
    const currentLang = i18n.language;
    const category = c.category_type;
    return currentLang === 'ru' ? category.name_rus :
      currentLang === 'en' ? category.name_eng :
        category.name_tm;
  };

  const groupedComplaint = complaint.reduce((acc, item) => {
    const category = getCategory(item) || t('other');
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});


  const getQuestion = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.rus_question;
    } else if (currentLang === 'en') {
      return laws.eng_question;
    }
    return laws.tm_question;
  };

  const getAnswer = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.rus_answer;
    } else if (currentLang === 'en') {
      return laws.eng_answer;
    }
    return laws.tm_answer;
  };

  const getMadda = (laws) => {
    const currentLang = i18n.language;
    if (currentLang === 'ru') {
      return laws.rus_madda;
    } else if (currentLang === 'en') {
      return laws.eng_madda;
    }
    return laws.tm_madda;
  };

  const toggleCategory = (category) => {
    setExpandedCategory(expandedCategory === category ? null : category);
  };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  const [isLgScreen, setIsLgScreen] = useState(window.innerWidth >= 912);
  useEffect(() => {
    const handleResize = () => {
      setIsLgScreen(window.innerWidth >= 912);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return (
    <GlobalLayout
      title={`${t('complaint_board')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords=""
    >
      <div className='mb-20'>
        <Layout
          title={t('complaint_board')}
          layoutBgImg={isLgScreen ? layoutBgImg : layoutBgImg2}
          color={isLgScreen ? 'primary' : 'white'}
        />
        <div className='w-full media'>
          <div className='bg-white dark:bg-dark-box mt-8 pt-4 pb-1'>
            {isLoading ? <Loading /> : (
              Object.entries(groupedComplaint)?.map(([category, items]) => (
                <div key={category} className='mb-4'>
                  {/* Category Title */}
                  <div
                    className='cursor-pointer flex p-3 gap-4
                               items-center justify-between'
                    onClick={() => toggleCategory(category)}
                  >
                    <h2 className='text-lg font-semibold flex gap-3 items-center
                                   hover:text-primary dark:text-dark-text'>
                      <img src={LotAngle} alt="angle" />
                      {category}
                    </h2>
                    <span className={`transform transition-transform duration-300 
                                     ${expandedCategory === category ? 'rotate-180'
                        : 'rotate-0'}`}
                    >
                      <ArrowDropDown className='text-blackOpacity dark:text-dark-text' />
                    </span>
                  </div>

                  {/* FAQ Items under this Category */}
                  {expandedCategory === category && (
                    <div className='mx-6'>
                      {items.map((item, index) => (
                        <div
                          key={item.id}
                          className='border-b border-b-border'>
                          <div
                            onClick={() => toggleAccordion(index)}
                            className='cursor-pointer pt-4 pb-2 flex text-black
                                       dark:text-dark-text items-center gap-2'
                          >
                            <span>{index + 1}.</span>
                            <h3 className={`transition-colors  duration-300 
                                           ${activeIndex === index ? 'text-primary' : ''}`}
                            >     {getQuestion(item)}
                            </h3>
                          </div>
                          {activeIndex === index && (
                            <>
                              <div className='px-4 my-4 text-justify border-l-4 
                                            dark:text-dark-text border-primary'>
                                <p>{getAnswer(item)}</p>
                              </div>

                              {getMadda(item) ?
                                <Button
                                  variant="contained"
                                  onClick={handleOpen}
                                  sx={{ mb: 2 }}
                                  endIcon={<span> <ReadMore /> </span>}
                                >
                                  {t('full')}
                                </Button>
                                : ''}

                              <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-title"
                                aria-describedby="modal-description"
                              >
                                <Box
                                  sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    bgcolor: 'background.paper',
                                    boxShadow: 24,
                                    p: 4,
                                    width: { xs: '90vw', md: '70vw' },
                                    maxHeight: '90vh',
                                    overflowY: 'auto',
                                  }}
                                >
                                  <Typography id="modal-description" sx={{ mt: 2 }}>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: document ?
                                          getMadda(item) : ''
                                      }}
                                      className='leading-loose'
                                    />
                                  </Typography>
                                  <Button
                                    onClick={handleClose}
                                    sx={{ mt: 2 }}
                                    variant="contained"
                                    color="primary"
                                  >
                                    {t('close')}
                                  </Button>
                                </Box>
                              </Modal>

                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </GlobalLayout>
  )
}

export default ComplaintBoard